import { render, staticRenderFns } from "./InsightsTable.vue?vue&type=template&id=c97437fa&scoped=true&"
import script from "./InsightsTable.vue?vue&type=script&lang=js&"
export * from "./InsightsTable.vue?vue&type=script&lang=js&"
import style0 from "./InsightsTable.vue?vue&type=style&index=0&id=c97437fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97437fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDataTable,VIcon,VRow,VSpacer})
